"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.buttonSizes = void 0;
var buttonSizes = {
  s: {
    height: 30,
    labelIcon: 5,
    padding: 6
  },
  m: {
    height: 40,
    padding: 8,
    labelIcon: 7
  },
  l: {
    height: 52,
    padding: 10,
    labelIcon: 9
  }
};
exports.buttonSizes = buttonSizes;
var _default = {
  buttonSizes: buttonSizes
};
exports["default"] = _default;